import { ActivityDropdown as ActivityDropdownComponent } from '@vimeo/activity-dropdown';
import { useHeaderTracking } from '@vimeo/picox';
import { useViewer } from '@vimeo/viewer';

import { trackNavigationActionEvent } from '../../tracking';

export const ActivityDropdown = () => {
  const viewer = useViewer();
  const { trackHeaderNotificationBellClicked } = useHeaderTracking();
  if (!viewer || !viewer.user || !viewer.xsrft) {
    return <></>;
  }

  return (
    <ActivityDropdownComponent
      user={viewer.user}
      onClick={() => {
        trackNavigationActionEvent({
          copy: 'activity',
          element: 'dropdown_header',
          feature: 'activity',
          viewer,
        });
        trackHeaderNotificationBellClicked();
      }}
    />
  );
};
